import { useNavigate } from "react-router-dom";
import { goToTop } from "../Components/goToTop";

export type InputType =
    | "button"
    | "checkbox"
    | "color"
    | "date"
    | "datetime-local"
    | "email"
    | "file"
    | "hidden"
    | "image"
    | "month"
    | "number"
    | "password"
    | "radio"
    | "range"
    | "reset"
    | "search"
    | "submit"
    | "tel"
    | "text"
    | "time"
    | "url"
    | "week";

export function getAppCurrencyType(): string {
    return localStorage.getItem("currency_symbol") || "£";
}

export const useGoBack = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    return goBack;
};

export const publicURL = process.env.PUBLIC_URL;

export const amountDisplay = (amount: number) => {
    const currencySymbol = localStorage.getItem("currency_symbol") || "£";
    const num = Number(amount);

    return (
        currencySymbol +
        " " +
        num.toLocaleString("en-GB", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })
    );
};

export function getFileNameFromUrl(url: string): string {
    try {
        const pathname = new URL(url).pathname;
        return pathname.substring(pathname.lastIndexOf("/") + 1);
    } catch {
        return "document";
    }
}